import styled from 'styled-components';

export const Input = styled.input`
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 14px;

	&:focus {
		border-color: #007bff;
		outline: none;
	}
`;

export const Select = styled.select`
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 14px;
	background-color: #f9f9f9;

	&:focus {
		border-color: #007bff;
		outline: none;
	}
`;

export const Button = styled.button`
	background-color: #007bff;
	color: white;
	border: none;
	padding: 8px 12px;
	cursor: pointer;
	border-radius: 4px;

	&:hover {
		background-color: #0056b3;
	}
`;

export const CustomTable = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

export const TableHeader = styled.thead`
	background-color: #f2f2f2;
	font-size: 16px;
`;

export const TableBody = styled.tbody`
	font-size: 16px;
`;

export const TableRow = styled.tr`
	&:nth-child(even) {
		background-color: #f0f0f0;
	}
`;

export const TableCell = styled.td`
	padding: 8px;
	text-align: left;
`;

export const TableHeadCell = styled.th`
	padding: 8px;
	background-color: #cdcdcd;
	text-align: left;
`;

export const PaginationButton = styled.button`
	background-color: #007bff;
	color: white;
	border: none;
	padding: 8px 12px;
	cursor: pointer;
	border-radius: 4px;
	margin: 0 5px;

	&:hover {
		background-color: #0056b3;
	}
`;

export const PaginationContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
`;

export const PageInfo = styled.div`
	display: flex;
	align-items: center;
`;

export const NavigationButtons = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;
